<template>
  <div class="injure-photos">
    <el-tabs
      :value="activeInjured"
      @input="$store.commit('app/SET_ACTIVEINJURED', $event)"
    >
      <el-tab-pane
        v-for="(party, index) in injuredPartys"
        :key="index"
        :label="'伤者照片-' + (index + 1)"
        :name="index + ''"
      >
        <div>
          <div
            v-for="(prop, key) of config"
            :key="key"
            class="photo-wrapper"
          >
            <i
              v-if="party[key]"
              class="el-icon-close delete-photo"
              @click="party[key] = ''"
            />
            <el-image
              class="accident-image"
              :src="party[key]"
              :preview-src-list="[party[key]]"
            >
              <template #error>
                <div
                  v-loading="prop.loading"
                  :style="{
                    cursor: isDisabled.value ? 'not-allowed' : 'pointer'
                  }"
                  class="required-upload"
                  @click="
                    () => {
                      if(isDisabled.value){
                        return
                      }
                      prop.loading = true;
                      capture()
                        .then(base64Str =>
                          getfaceInfo(key,base64Str)
                        )
                        .then(({ data: url }) => {
                          $set(party, key, url);
                          if (prop.afterUpload) {
                            return prop.afterUpload(party, url);
                          }
                        })
                        .finally(() => {
                          prop.loading = false;
                        });
                    }
                  "
                >
                  拍照截图
                </div>
              </template>
            </el-image>
            <div class="required-name">
              {{ prop.label }}
            </div>
          </div>
        </div>
        <myDialog :logTitle="'人脸识别信息'" class="faceData" :logHeight="'430px'" :showDialog.sync="faceInfoDialog">
          <el-table :data="faceData" >
            <el-table-column label="选择" width="130" align="center">
              <template slot-scope="scope">
                <el-radio
                  v-model="selectFace"
                  :label="scope.$index"
                  @change.native="radioChange(scope.row)"
                >
                  {{ }}
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column
              label="序号"
              type="index"
              align="center"
              width="130" />
            <el-table-column property="name" label="姓名" align="center" />
            <el-table-column
              property="personId"
              label="身份证"
              align="center"
            />
          </el-table>
          <div class="dialog-footer">
            <span
              class="partyBtn btn1"
              @click="cacleLog"
            >
              取 消
            </span>
            <span
              class="partyBtn btn2"
              @click="chooseFace"
            >
              确 定
            </span>
          </div>
        </myDialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { upload } from '@/api/common/upload';
import { getFaceByPhoto } from '@/api/common/third-party';
import myDialog from '@/components/custom/myDialog.vue'
export default {
  components: {myDialog},
  inject: {
    targetRefs: { default: null },
    isDisabled: { default: () => ({ value: false }) },
  },
  props: {
    injuredPartys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      faceInfoDialog: false, // 人脸识别身份弹窗选择
      selectFace:'', // 人脸识别选项
      faceData:[], // 人脸数据
      chooseData:'', // 选择的数据
      changeData:'', // 切换当事人时的数据
      config: {
        faceInfo: {
          label: '伤者照片',
          loading: false,
        }
      }
    };
  },
  computed: {
    activeInjured() {
      return this.$store.getters.activeInjured;
    },
    previewSrcList() {
      return Object.keys(this.config)
        .map(key => this.injuredPartys[this.activeInjured * 1][key])
        .filter(Boolean);
    }
  },
  methods: {
    upload,
    capture() {
      return this.targetRefs.video.screenShot();
    },
    getfaceInfo(key,url) {
      if(key === 'faceInfo'){
        getFaceByPhoto({photo:url}).then(res=>{
          // console.log(res);
          if (res.code===0 && res.data.length) {
            this.faceData = res.data;
            this.faceInfoDialog = true;
          }
        }).catch(err => {
          console.log(err);
        });
      }
     return upload({ fileName: 'xxx.png', base64Str:url });
    },
    radioChange(data) {
      this.chooseData = data;
    },
    chooseFace() {
      this.selectFace = '';
      this.faceInfoDialog = false;
      this.$set(this.injuredPartys[Number(this.activeInjured)], 'name', this.chooseData.name);
      this.$set(this.injuredPartys[Number(this.activeInjured)], 'identityNum', this.chooseData.personId);
    },
    cacleLog() {
      this.faceInfoDialog = false;
      this.chooseData = '';      
      this.selectFace = '';
    }
  }
};
</script>
<style lang="less">
.injure-photos {
  .el-tabs__header {
    display: none;
    margin-bottom: 10px;
  }
  .photo-wrapper {
    width: 180px;
    margin-bottom: 50px;
    .accident-image {
      width: 180px;
      height: 120px;
      border-radius: 2px;
      .required-upload {
        font-size: 16px;
        color: #17ECFE;
        width: 180px;
        height: 120px;
        background: #0B2756;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }

    .required-name {
      font-size: 12px;
      font-weight: 400;
      text-align: center;   
      color: #17ECFE;
    }

    .delete-photo {
      cursor: pointer;
      display: none;
      position: absolute;
      right: 5px;
      top: -2px;
      font-weight: 500;
      font-size: 22px;
      z-index: 10;
      color: #ff4949;
    }
    position: relative;

    &:hover {
      .delete-photo {
        display: block;
      }
    }
  }
  .capture {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 120px;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 2px;
    font-size: 16px;
    font-weight: 400;
    color: #226eff;
    margin-top: -2px;
  }
}
</style>
